<template>
  <div :class="`my-market-wrap ${t('curlan')}`">
    <!-- 港股 -->
    <Item
      packType="hk"
      :title="t('common.sotck_hk')"
    >
      <div class="card default bg-default"  @click="toDetail('hk')">
        <h2 class="tit">{{t('my_market.lv1.txt_1')}}</h2>
        <p class="des">{{t('my_market.lv1.txt_2_1')}}</p>
        <span class="active" v-if="hKLevelType+'' === '1'">{{t('my_market.active')}}</span>
      </div>
      <div class="card lv2 bg-lv2"   @click="clickHK">
        <div style="font-size:0;">
          <span class="tit">{{t('my_market.lv2.txt_1')}}</span>
          <!-- <span :class="`sp2 ${t('curlan')}`" style="word-break:keep-all;white-space:nowrap;">{{t('my_market.lv2.txt_11', {money: hKMinPrice})}}</span> -->
        </div>
        <p class="des">{{t('my_market.lv2.txt_2')}}</p>
        <template v-if="likeVIP&&hKLevelType+'' === '2'">
          <span class="active" >{{t('my_market.lv2.txt_12')}}</span>
        </template>
        <template v-else>
          <span class="active" v-if="hKLevelType+'' === '2'">
            {{hKRemainDays ? t('my_market.lv2.txt_5',{
              day: hKRemainDays
            }) : t('my_market.active')}}
          </span>
          <a href="javascript:;" class="btn-buy" @click="toShopping">{{t(['', 'my_market.buy', 'my_market.renew'][hKLevelType])}}</a>
        </template>
        
      </div>
    </Item>
    <!-- 美股 -->
    <Item
      packType="us"
      :title="t('common.sotck_us')"
    >
      <div class="card default bg-lv1"  @click="toDetail('us')">
        <h2 class="tit">{{t('my_market.lv1.txt_5')}}</h2>
        <p class="des">{{t('my_market.lv1.txt_2')}}</p>
        <span class="active" v-if="uSLevelType+'' === '1'">{{t('my_market.active')}}</span>
      </div>
      <div class="card lv2 bg-lv2"  @click="toDetail('us')">
        <h2 class="tit">{{t('my_market.lv2.txt_1')}}</h2>
        <p class="des">{{t('my_market.lv2.txt_3')}}</p>
        <span class="active" v-if="uSLevelType+'' === '2'">{{likeVIP?t('my_market.lv2.txt_12'):t('my_market.active')}}</span>
      </div>
    </Item>
    <!-- A股 -->
    <!-- <Item
      packType="A"
      :title="t('common.sotck_A')"
    >
      <div class="card default bg-default" @click="toDetail('cn')">
        <h2 class="tit">{{t('my_market.lv2.txt_8')}}</h2>
        <p class="des">{{t('my_market.lv2.txt_9')}}</p>
        <span class="active" v-if="aLevelType === '1'">{{t('my_market.active')}}</span>
      </div>
    </Item>
    
    <div class="warn-wrap">
      <div class="warn-title">{{t('my_market.warn_title')}}</div>
      <div class="warn-desc" v-html="t('my_market.warn_desc')"></div>
    </div> -->

  </div>
</template>

<script>
import { onMounted, computed, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import apiOther from '@/api/modules/api-other'
import SecApi from '@/api/modules/api-sec.js'
import userAgent from '@/utils/ua-parser.js'
import Item from './item'
import * as tips from '@/utils/tips'
import { useRouter } from 'vue-router'
export default {
  components: {
    Item
  },
  setup() {
    const {t} = useI18n()
    const router = useRouter()
    const store = useStore()
    const userInfo = computed(() => store.getters['user/userInfo'])
    const packageInfo = reactive({
      hKLevelType: 1, // 港股level级别
      hKRemainDays: 0, // 港股套餐剩余天数,仅在大于1时生效
      hKMinPrice: 0, // 港股套餐最低价格
      uSLevelType: '2', // 美股level级别,目前默认返回2
      uSRemainDays: 0, // 美股套餐剩余天数,仅在大于1时有用
      aLevelType: '1', // A股level级别,目前默认返回1
      aRemainDays: 0, // A股套餐剩余天数,仅在大于1时有用
      likeVIP: false, // 是否是白银以上的点赞会员
    })

    onMounted(() => {
      findPackageInfo()
      document.title = t('my_market.title')
    })

    const toJumpUrl = (url) => {
      if(userAgent.isApp()) {
        const obj = {
          url: url,
          bottomTab: false, // 是否需要底部导航栏  //仅限于首页
          backHeader: true, // 是否需要后退按钮
          isFresh: false, // 是否下拉可刷新
          elasticBorder: true, // 是否弹性边框        //针对IOS
          isCloseBtn: true, // 是否关闭按钮
          isNeedHeader: true, // 是否需要头部
          isNewPage: true
        }
        window.JFSTOCK.jumpUrl(obj)
        return
      }
      window.location.href = url
    }

    const clickHK = e=>{
      let curTarg = e.target;
      // console.log(curTarg)
      if(curTarg.className.includes('btn-buy')){
        return 
      }    
      toDetail('hk')
    }

    const toDetail = (dtype)=>{
      router.push({
        name:'intro-quota',
        query:{
          dtype
        }
      })
    }

    // 获取用户行情套餐
    const findPackageInfo = async() => {
      const { UserCode, uId } = userInfo.value
      let params = {
        userId: UserCode || uId
      }
      let res = await apiOther.findPackageInfo(params)
      if (res) {
        for(let key in packageInfo) {
          packageInfo[key] = res[key]
        }
      }
    }
    // 获取用户开户状态
    const getUserOpenInfo = async(callback)=>{
      try{
        let result = await SecApi.findCrmllserStatus()
        console.log(result)
        let { openAccountStatus } = result
        if(openAccountStatus){
          typeof callback === 'function' && callback()
        }else{
          // 未开户
          tips.toast({
            type: 'error',
            txt: t('common.unopen'),
          })
        }
      }catch(error){
        console.log('getUserOpenInfo---',error)
      }
    }

    // 去购买
    const toShopping = (e) => {
      let url = window.BUY_QUOTES_URL
      // 判断用户开户状态
      getUserOpenInfo(()=>{
        toJumpUrl(url) // eslint-disable-line
      })
      e.preventDefault()
      return
      
    }

    return {
      t,
      ...toRefs(packageInfo),
      toShopping,
      toDetail,
      clickHK
    }
  },
}
</script>

<style lang="stylus">
@import '~@/assets/stylus/variable.styl'
@import '~@/assets/stylus/mixin.styl'
.my-market-wrap
  width: 100%
  height: 100%
  overflow: scroll
  padding-top 12px
  box-sizing border-box
  background: #fff
  .bg-default
    // bg-image2('my-market/icon-default', 80px 110px, true)
    background-position: 494px 80px
  .bg-lv1
    // bg-image2('my-market/icon-lv1', 100px 118px, true)
    background-position: 490px 64px
  .bg-lv2
    // bg-image2('my-market/icon-lv2', 102px 118px, true)
    background-position: 490px 68px
  .warn-wrap
    padding-top 16px
    padding-left 48px
    padding-bottom 64px
    box-sizing: border-box
    .warn-title
      color #333333
      font-size 28px
      font-weight bold
      line-height 40px
      padding-bottom 6px
    .warn-desc
      color #666666
      font-size 28px
      line-height 40px
  .card
    position relative
    height: auto
    width: 622px !important
    height 248px !important
    margin: 0 auto
    padding 32px 30px
    background-color: #F8FBFF;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden
    .tit
      font-size: 40px;
      font-weight: bold
      color: #000
      line-height: 60px
      position: relative
    .sp2
      margin-left: 46px
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      line-height: 40px;
      &.zh-EN,&.zh-VI
        padding-right 46px
        margin-left 0px
        font-size 24px
    .des
      margin-top: 12px
      font-size: 28px;
      color: #6F787E;
      line-height: 40px;
    .active
      position: absolute
      top 0
      right 0
      padding 0 22px
      height: 48px;
      font-size: 24px;
      color: #3E1414;
      line-height: 48px;
      text-align: center
      background: linear-gradient(-270deg, #F3DBB2 0%, #DBB87F 100%);
      border-radius: 0px 16px 0px 16px;
    .btn-buy
      align-self: flex-end
      display: inline-block
      margin-top: 14px
      width: 154px;
      height: 56px;
      font-size: 28px;
      color: #FFFFFF;
      text-align: center
      line-height: 56px;
      background: #015FFF;
      border-radius: 35px;
      position absolute
      bottom 30px
    &.default
      margin-bottom: 16px
  .package-hk
    bg-image('hk-bg')
    .card
      background-color #FFF8F5
      .tit::after
        content: ''
        position: absolute
        bg-image('arrow1')
        top 50%
        transform: translate(8px,-50%)
      &.bg-default
        bg-image2('my-market/hk-default',80px,110px, true)
      &.bg-lv2
        bg-image2('my-market/hk-lv2',102px,118px,true)
  .package-us
    bg-image('us-bg')
    .card
      background-color #EFF5FF
      .tit::after
        content: ''
        position: absolute
        bg-image('arrow2')
        top 50%
        transform: translate(8px,-50%)
      &.bg-lv1
        bg-image2('my-market/us-lv1',100px,118px,true)
      &.bg-lv2
        bg-image2('my-market/us-lv2',102px,118px,true)
  .package-A
    bg-image('cn-bg')
    .card
      background-color #FFF6F6
      .tit::after
        content: ''
        position: absolute
        bg-image('arrow1')
        top 50%
        transform: translate(8px,-50%)
      &.bg-default
        bg-image2('my-market/cn-lv1',100px,118px,true)
  &.zh-EN,&.zh-VI
    .card
      padding-top 40px
    .package-hk
      .card
        &.bg-default
          height 288px !important

</style>
